import "./influencerList.css";
import { DataGrid } from "@material-ui/data-grid";
import { DeleteOutline } from "@material-ui/icons";
import { advertList, influencerList, userRows } from "../../dummyData";
import { Link } from "react-router-dom";
import { useState } from "react";

export default function AdvertList() {
  const [data, setData] = useState(influencerList);

  const handleDelete = (id) => {
    setData(data.filter((item) => item.id !== id));
  };

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    {
      field: "kullanıcıAdı",
      headerName: "Kullanıcı Adı",
      width: 175,
    },
    { field: "instaLink", headerName: "İnstagram Linki", width: 300 },

    {
      field: "onayNotu",
      headerName: "Onay Notu",
      width: 450,
    },
    {
      field: "action",
      headerName: "Kullanıcı Onay Durumu",
      width: 250,
      renderCell: (params) => {
        return (
          <>
            <Link to={"/advertDetail/" + params.row.id}>
              <button className="userListEdit">Onayla</button>
            </Link>
            <Link to={"/advertDetail/" + params.row.id}>
              <button className="userListRed">Reddet</button>
            </Link>
          </>
        );
      },
    },
  ];

  return (
    <div className="userList">
      <DataGrid
        rows={data}
        disableSelectionOnClick
        columns={columns}
        pageSize={8}
        checkboxSelection
      />
    </div>
  );
}
